import React, { Component } from 'react';
import { Container, Table, Button, InputGroup, FormControl, Row, Col } from 'react-bootstrap';
import axios from 'axios';
import { withRouter } from 'react-router-dom';

import { AdminNav, Loading } from '../../helpers';

import './styleTable.css';
import { addCommaInNumber } from '../../helpers/function';
import _ from 'lodash'
class CertificateRequested extends Component {
  constructor(props) {
    super(props);
    this.state = {
      FinancialSheet: {},
      licenseID: '9999999999999',
      certificateSheetArr: [],
      rawLicenseData: {}
    };
    this.handleInputLicense = this.handleInputLicense.bind(this)
  }

  componentWillMount() {
  }
  handleInputLicense(e) {
    this.setState({
      ...this.state,
      licenseID: e.target.value
    })
  }
  handleClickSearchLicense(licenseID) {
    if (licenseID !== '9999999999999') {

      let viewCheckWeightSheetByLicenseID = axios.post(
        'https://backend1.riceinspections.com/testCB',
        {
          data: { 'licenseID': licenseID },
        }
      )
      const url = 'https://backend2.riceinspections.com'
      let rawLicense = fetch(`${url}/search?code=${licenseID}`).then(res => res.json())


      Promise.all([viewCheckWeightSheetByLicenseID, rawLicense]).then((rawRes) => {
        let checkWeightData = rawRes[0].data
        let rawLicenseData = rawRes[1]
        if (checkWeightData) {
          let jobIDArr = []
          Object.values(checkWeightData).map((resValue) => {
            jobIDArr.push({
              licenseID: licenseID,
              jobID: resValue['jobID']
            })
          })
          jobIDArr = _.uniqWith(jobIDArr, _.isEqual)
          let certificateSheetComplete = axios.post(
            'https://backend1.riceinspections.com/testDE',
            {
              data: { ...jobIDArr }
            }
          )
          certificateSheetComplete.then((certificateSheetCompleteData) => {
            if (certificateSheetCompleteData?.data?.data) {
              let certificateArr = []
              if (Array.isArray(certificateSheetCompleteData.data.data)) {
                certificateSheetCompleteData.data.data.map((certificateSheetCompleteDataSingleObject) => {
                  Object.values(certificateSheetCompleteDataSingleObject).map((certificateObjectData) => {
                    certificateArr.push(certificateObjectData)
                  })
                })
              }
              this.setState({
                certificateSheetArr: certificateArr,
                rawLicenseData: rawLicenseData,
              })
            }
          })
        } else {
          alert('ไม่พบประวัติใบรับรอง')
        }
      })
    }
  }
  renderCertificateTable(certificateSheetArr) {
    let certificateSheetArrSorted = certificateSheetArr.sort((a, b) => {
      if (a && b) {
        return Object.values(a)[0]['subID']
      }
    })
    let index = 99
    let newCertificateSheetArrWithGroup = []
    certificateSheetArrSorted.map((certificateSheetCompleteSingle) => {
      if (certificateSheetCompleteSingle) {
        if (Array.isArray(newCertificateSheetArrWithGroup[parseInt(certificateSheetCompleteSingle['subID'])])) {
          if (certificateSheetCompleteSingle['PackingType1']) {
            newCertificateSheetArrWithGroup[parseInt(certificateSheetCompleteSingle['subID'])].push(certificateSheetCompleteSingle)
          }
        } else {
          if (certificateSheetCompleteSingle['PackingType1']) {
            newCertificateSheetArrWithGroup[parseInt(certificateSheetCompleteSingle['subID'])] = [certificateSheetCompleteSingle]
          }
        }
      }
    })
    return newCertificateSheetArrWithGroup.map((newCertificateSheetArrWithGroupSingle, idx) => {
      if (newCertificateSheetArrWithGroupSingle) {
        let licenseDetail = this.state.rawLicenseData['PaperlessDetail']['LicenseDetail']
        let sumWeight = 0
        if (!Array.isArray(this.state.rawLicenseData['PaperlessDetail']['LicenseDetail'])) {
          licenseDetail = [licenseDetail]
        }
        let totalWeight = licenseDetail[idx]['NetWeightTON']
        console.log(newCertificateSheetArrWithGroupSingle)
        return (<div>

          <Container>
            <Row>
              <Col><p>รายการที่ {parseInt(idx) + 1}   </p></Col>
              <Col><p>ชนิดข้าว <br />{newCertificateSheetArrWithGroupSingle[0]?.['checkWeight']?.['ProductDescription'] || newCertificateSheetArrWithGroupSingle[0]?.['wtf1']} </p></Col>
              <Col><p>Loading <br />{newCertificateSheetArrWithGroupSingle[0]?.['checkWeight']?.['LoaingType'] || ''}  </p></Col>
            </Row>
          </Container>
          <Table bordered hover>
            <thead>
              <tr>
                <th scope="col">คำสั่งจ่ายงาน</th>
                <th scope="col">วันที่ตรวจบรรทุก</th>
                <th scope="col">เรือใหญ่</th>
                <th scope="col">โกดัง</th>
                <th scope="col">จังหวัด</th>
                <th scope="col">น้ำหนัก/ตัน</th>
                <th scope="col">น้ำหนักสุทธิ/ตัน</th>
              </tr>
            </thead>
            <tbody>
              {newCertificateSheetArrWithGroupSingle.map((newCertificateSheetArrWithGroupSingleDetail) => {
                sumWeight += parseFloat(newCertificateSheetArrWithGroupSingleDetail['TotalNett']) / 1000 || (parseFloat(newCertificateSheetArrWithGroupSingleDetail['bagQuantity']) * parseFloat(newCertificateSheetArrWithGroupSingleDetail['netWeight'])) / 1000
                return (<tr id={''} onClick={() => { }}>
                  <td>{newCertificateSheetArrWithGroupSingleDetail['jobID']}</td>
                  <td>{newCertificateSheetArrWithGroupSingleDetail['shippingDate']}</td>
                  <td>{newCertificateSheetArrWithGroupSingleDetail['vehicleName']}</td>
                  <td>{newCertificateSheetArrWithGroupSingleDetail['godown']}</td>
                  <td>{newCertificateSheetArrWithGroupSingleDetail['surveyProvince']}</td>
                  <td>{addCommaInNumber(parseFloat(newCertificateSheetArrWithGroupSingleDetail['TotalNett']) / 1000 || (parseFloat(newCertificateSheetArrWithGroupSingleDetail['bagQuantity']) * parseFloat(newCertificateSheetArrWithGroupSingleDetail['netWeight'])) / 1000)}</td>
                  <td>{addCommaInNumber(licenseDetail[parseInt(newCertificateSheetArrWithGroupSingleDetail['subID'])]['NetWeightTON'])}</td>
                </tr>
                )
              })}
            </tbody>
            <tfoot>
              <tr id={''} onClick={() => { }}>
                <td>{}</td>
                <td>{}</td>
                <td>{}</td>
                <td>น้ำหนักที่แจ้งขอหนังสือรับรอง/ตัน</td>
                <td>{sumWeight}</td>
                <td>น้ำหนักคงเหลือ/ตัน</td>
                <td>{(Math.round(parseFloat(totalWeight * 10000000 - sumWeight * 10000000)) / 10000000).toFixed(6)}</td>
              </tr>
            </tfoot>
          </Table>
        </div>
        )
      }

    })
  }
  handlePressSearchLicense(e, licenseID) {
    if (e.key == 'Enter') {
      this.handleClickSearchLicense(licenseID)
    }
  }
  render() {
    let { FinancialSheet } = this.state;
    if (!FinancialSheet) {
      return (<Container>
        <AdminNav></AdminNav>
        <Loading />
      </Container>)
    }
    return (
      <Container>
        <AdminNav />
        {/* <Nav className="justify-content-end">
                        <Link to={{ pathname: '/AddJob', state:  'bar' }}><Button variant="success">เพิ่ม</Button></Link>
                    </Nav> */}



        <div><label>เลขที่ใบอนุญาต</label>
          <InputGroup className="mb-3">
            <FormControl
              onChange={this.handleInputLicense}
              onKeyDown={(e) => { this.handlePressSearchLicense(e, this.state.licenseID) }}
            />
            <InputGroup.Append>
              <Button onClick={() => { this.handleClickSearchLicense(this.state.licenseID) }}>ค้นหา</Button>
            </InputGroup.Append>
          </InputGroup>
        </div>
        <div><label>ชื่อบริษัท</label>
          <InputGroup className="mb-3">
            <FormControl
              disabled={true}
              placeholder={this.state.rawLicenseData['Recipient'] || ''}
            />
          </InputGroup>
        </div>
        <div><label>ประเทศปลายทาง</label>
          <InputGroup className="mb-3">
            <FormControl
              disabled={true}
              placeholder={this.state.rawLicenseData['DestinationCountry'] || ''}
            />
          </InputGroup>
        </div>


        {this.renderCertificateTable(this.state.certificateSheetArr)}

      </Container>
    );
  }
}

export default withRouter(CertificateRequested);

